// Spare Parts Module - Data Types

export type MoldSparePartType = 'stock' | 'custom' | 'insert';

export type SparePartCategory =
  | 'Ejector' | 'Cooling' | 'Hot Runner' | 'Slides/Lifters' 
  | 'Seals/O-rings' | 'Fasteners' | 'Sensors' | 'Other';

export type SparePartStatus = 'Active' | 'Obsolete';
export type StockStatus = 'OK' | 'Low' | 'Out';
export type TransactionType = 'Receive' | 'Issue' | 'Adjust' | 'Reserve' | 'Unreserve';

export interface SparePart {
  id: string;
  part_id: string; // e.g. SP-00123
  part_name: string;
  part_number?: string;
  category: SparePartCategory;
  description?: string;
  unit: string; // pcs, set, m, etc.
  manufacturer?: string;
  supplier?: string;
  lead_time_days?: number;
  unit_cost?: number;
  stock_on_hand: number;
  stock_reserved: number;
  reorder_point?: number;
  reorder_qty?: number;
  storage_location_code?: string;
  is_critical: boolean;
  on_order?: boolean;
  order_qty?: number;
  expected_delivery_date?: string;
  order_notes?: string;
  status: SparePartStatus;
  created_at: string;
  updated_at: string;
}

export interface MoldSparePart {
  mold_id: string;
  part_id: string;
  part_type: MoldSparePartType;
  typical_usage_notes?: string;
  preferred_qty_on_hand?: number;
  is_common_failure_part: boolean;
  created_at: string;
}

export interface SparePartTransaction {
  transaction_id: string;
  part_id: string;
  type: TransactionType;
  qty: number;
  related_wo_id?: string;
  related_mold_id?: string;
  performed_by: string;
  timestamp: string;
  notes?: string;
}

// Derived helpers
export function getAvailableStock(part: SparePart): number {
  return part.stock_on_hand - part.stock_reserved;
}

export function getStockStatus(part: SparePart): StockStatus {
  const available = getAvailableStock(part);
  if (available <= 0) return 'Out';
  if (part.reorder_point && available <= part.reorder_point) return 'Low';
  return 'OK';
}
